const LINE_BROWSER_PATTERN = /\bLine\/[\d.]+/i
const EXTERNAL_BROWSER_PARAM = 'openExternalBrowser'
const GOOGLE_LOGIN_PATH = '/users/auth/google_oauth2'
const LOGIN_PATH = '/users/sign_in'

function currentUserAgent() {
  return typeof navigator === 'undefined' ? '' : navigator.userAgent
}

function currentOrigin() {
  return typeof window === 'undefined' ? 'https://localhost' : window.location.origin
}

// 一般 LINE 內建瀏覽器不一定是 LIFF client，因此以 User-Agent 做登入前的漸進式偵測。
export function isLineInAppBrowser(userAgent = currentUserAgent()) {
  return LINE_BROWSER_PATTERN.test(userAgent)
}

export function withLineExternalBrowser(target, base = currentOrigin()) {
  const url = new URL(target, base)
  url.searchParams.set(EXTERNAL_BROWSER_PARAM, '1')
  return url.toString()
}

export function buildGoogleLoginHref(userAgent = currentUserAgent(), base = currentOrigin()) {
  if (!isLineInAppBrowser(userAgent)) return GOOGLE_LOGIN_PATH

  return withLineExternalBrowser(LOGIN_PATH, base)
}
